var _defs, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMusic(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 344 293",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #7c3bec;\n      }\n\n      .cls-2 {\n        fill: #fefefe;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M118.37,226.43c0,6.19-2.18,11.38-5.61,15.31-20.02,22.96-67.6,20.93-83.58-1.77-5.67-8.06-5.52-17.94-.15-25.96,12.67-17.09,37.09-20.62,58.13-16.33v-126.59c0-6.81,4.05-13.3,10.6-15.26l35.58-10.61L255.24,9.35c4.79-1.41,9.95.68,13.39,3.39s5.39,7.13,5.38,12.38l-.13,172.79c0,8.19-6.63,14.96-12.77,19.23-21.01,14.62-57.34,12.96-74.26-5.83-8-8.88-8.2-21.17-.79-30.33,4.58-5.41,10.39-9.04,16.98-12.01,12.87-4.64,26.38-5.52,40.03-2.38v-89.84s-124.71,36.49-124.71,36.49v113.18Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMusic);
export default __webpack_public_path__ + "static/media/music.793ca07be83f5201805069c783c96c69.svg";
export { ForwardRef as ReactComponent };